import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { recordAnswer } from 'client/actions/survey';
import Translate, { TranslateProps } from 'client/components/translate';
import Button from 'client/components/button/button';

const propTypes = {
  id: PropTypes.string.isRequired,
  text: TranslateProps.isRequired,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      text: TranslateProps.isRequired,
      value: PropTypes.string.isRequired,
      className: PropTypes.string,
    }),
  ).isRequired,
  answer: PropTypes.string,
  recordAnswer: PropTypes.func.isRequired,
  style: PropTypes.object,
  clickHandler: PropTypes.func,
};

const defaultProps = {
  answer: null,
  style: null,
  clickHandler: () => {},
};

class SurveyQuestion extends Component {
  constructor(props) {
    super(props);
    this.shouldShow = !props.answer;
  }

  recordAnswer({ key, value }) {
    this.props.recordAnswer({
      key,
      value,
    });
    this.props.clickHandler(value);
  }

  // Adds margin-right to first button to avoid segment
  // eslint-disable-next-line no-confusing-arrow
  addPadding = index => index === 0 ? { marginRight: '1rem' } : {};

  render() {
    if (!this.shouldShow) {
      return null;
    }

    const { text, id, buttons, style } = this.props;

    return (
      <div className="survey-question" style={style}>
        {this.props.answer ? (
          <div className="thanks">
            <h3>Thanks for your input!</h3>
            <img
              src="https://images.contentful.com/heg7gyzix6dq/6PVsMyz2LKM4wgsOWkyUoU/d49dcc40b55f8612949a6bbfd907b527/stride-love.svg"
              alt="" />
          </div>
        ) : (
          <div className="question">
            <h3>
              <Translate {...text} />
            </h3>
            <div className="actions flex-row">
              {buttons.map((button, idx) => (
                <Button
                  key={button.text.path}
                  className={button.className}
                  style={this.addPadding(idx)}
                  clickHandler={() =>
                    this.recordAnswer({
                      key: id,
                      value: button.value,
                    })
                  }>
                  <Translate {...button.text} />
                </Button>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }
}
SurveyQuestion.propTypes = propTypes;
SurveyQuestion.defaultProps = defaultProps;

const mapStateToProps = (state, ownProps) => ({
  answer: state.surveyData[ownProps.id],
});

export default connect(mapStateToProps, {
  recordAnswer,
})(SurveyQuestion);
